import { render, staticRenderFns } from "./trifle.vue?vue&type=template&id=1527d553&scoped=true&"
import script from "./trifle.vue?vue&type=script&lang=js&"
export * from "./trifle.vue?vue&type=script&lang=js&"
import style0 from "./trifle.vue?vue&type=style&index=0&lang=css&"
import style1 from "./trifle.vue?vue&type=style&index=1&id=1527d553&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1527d553",
  null
  
)

export default component.exports